var map = {
	"./Cervejas-bud-2.jpg": 66532,
	"./Cervejas-bud.jpg": 78700,
	"./amstel.jpg": 37341,
	"./bavaria.jpg": 32360,
	"./black.jpg": 11314,
	"./cintra.jpg": 28493,
	"./conti.jpg": 51434,
	"./devassa.jpg": 53350,
	"./ecobeer.jpg": 7124,
	"./eisenbah.jpg": 88438,
	"./estrela.jpg": 69151,
	"./glacial.jpg": 31764,
	"./kaiser.jpg": 36178,
	"./kirin.jpg": 90297,
	"./lokal.jpg": 98644,
	"./proibida.jpg": 33750,
	"./schin-2.jpg": 68748,
	"./schin.jpg": 46290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58686;